module.exports = __webpack_public_path__ + "static/media/ic_ellipse.6132cf47.svg";